import { Button } from "@/components/ui/button";
import { MessageSquare, Edit, Trash } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface MessageActionsProps {
  schedule: any;
  onViewMessage: (schedule: any) => void;
  onDeleteMessage: (scheduleId: string) => void;
}

export function MessageActions({ schedule, onViewMessage, onDeleteMessage }: MessageActionsProps) {
  const navigate = useNavigate();

  const handleEditMessage = (schedule: any) => {
    navigate("/agendamentos", {
      state: {
        isEditing: true,
        messageData: {
          id: schedule.id,
          ownerId: schedule.ownerId,
          propertyId: schedule.propertyId,
          message: schedule.message,
          interval: schedule.interval,
          nextDate: schedule.nextDate,
        },
      },
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onViewMessage(schedule)}
        className="flex items-center gap-2"
      >
        <MessageSquare className="h-4 w-4" />
        Ver Mensagem
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleEditMessage(schedule)}
        className="flex items-center gap-2"
      >
        <Edit className="h-4 w-4" />
        Editar
      </Button>
      <Button
        variant="destructive"
        size="sm"
        onClick={() => onDeleteMessage(schedule.id)}
        className="flex items-center gap-2"
      >
        <Trash className="h-4 w-4" />
        Excluir
      </Button>
    </div>
  );
}